/* Norwegian AI Summit — merkevaremerke og logo-lockups (forslag v1, for Apriil å videreutvikle).
   Mark «shift»: tre like søyler, hver flyttet ett nivå opp — The Next Shift, bokstavelig. Mark «n»: en stigende N med vertikale stammer.
   Alt i currentColor så merket følger ink/paper i dekkene. */
export const NasMark = ({ variant = "shift", size = 32, className = "", title = "Norwegian AI Summit" }) => (
  <svg className={`nas-mark ${className}`} width={size} height={size} viewBox="0 0 100 100" role="img" aria-label={title} data-testid={`nas-mark-${variant}`}>
    {variant === "n" ? (
      <path d="M11 100V31L89 69V0" fill="none" stroke="currentColor" strokeWidth="22" strokeLinejoin="miter" strokeLinecap="butt" />
    ) : (
      <>
        <rect x="0" y="40" width="24" height="60" fill="currentColor" />
        <rect x="38" y="20" width="24" height="60" fill="currentColor" />
        <rect x="76" y="0" width="24" height="60" fill="currentColor" />
      </>
    )}
  </svg>
);

/* Horisontal (default) eller stacked lockup. `theme` legger på «The Next Shift» som temalinje. */
export const NasLogo = ({ variant = "shift", stacked = false, size = 40, theme = false, className = "", testid = "nas-logo" }) => (
  <span className={`nas-logo ${stacked ? "stacked" : ""} ${className}`} style={{ "--s": `${size}px` }} data-testid={testid}>
    <NasMark variant={variant} size={stacked ? size * 1.1 : size * 0.72} />
    <span className="nas-word">{stacked ? <>Norwegian<br />AI Summit</> : "Norwegian AI Summit"}</span>
    {theme && <span className="nas-theme">The Next Shift</span>}
  </span>
);
